import React from "react";


import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import WebIcon from "@mui/icons-material/Web";
import SecurityIcon from "@mui/icons-material/Security";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useNavigate,useLocation } from "react-router-dom";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  Typography,
  Paper,
  Chip,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Footer from "./Footer";


const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

function SelexStudio() {

  const navigate = useNavigate();
  const location = useLocation();
const [releaseOpen, setReleaseOpen] = React.useState(false);

const releaseVersions = [
  {
    version: "Version 2.6XP",
    title: "Dynamic Optimization",
    details: [
      "Dynamic Optimization module added",
      "Supports one objective function",
      "Improved workflow for optimization cases",
    ],
  },
  {
    version: "Version 2.8XP",
    title: "Dynamic Optimization Upgrade",
    details: [
      "Dynamic Optimization module added",
      "Supports multiple objective function",
      "Enhanced SelexStudio workflow",
    ],
  },
  {
    version: "Version 3.0XP",
    title: "Advanced SelexStudio Release",
    details: [
      "Updated interface and release structure",
      "Supports multiple objective function",
      "Improved model loading and project handling",
      "Better support for managing Categorical DEP",
    ],
  },
];
const releases = [
  {
    version: "2.6XP",
    title: "SelexStudio V2.6XP",
    route: "/selexstudio/v2-6xp",
    points: ["Dynamic Optimization", "One Objective Function"],
  },
  {
    version: "2.8XP",
    title: "SelexStudio V2.8XP",
    route: "/selexstudio/v2-8xp",
    points: ["Dynamic Optimization", "Multi Objective Function"],
  },
  {
    version: "3.0XP",
    title: "SelexStudio V3.0XP",
    route: "/selexstudio/v3-0xp",
    points: [
      "Dynamic Optimization",
      "Multi Objective Function",
      "Managing Categorical DEP",
    ],
    latest: true,
  },
];



return (
  <Box
    sx={{
      minHeight: "100vh",
      background: "#fff",
      py: { xs: 8, md: 10 },
      px: 2,
    }}
  >

    <Dialog
  open={releaseOpen}
  onClose={() => setReleaseOpen(false)}
  maxWidth="sm"
  
  PaperProps={{
    sx: {
      borderRadius: "22px",
      overflow: "hidden",
      boxShadow: "0 24px 70px rgba(0,0,0,0.25)",
      transform: "translateY(40px)",
    },
  }}
>
  <DialogTitle
    sx={{
      background: "linear-gradient(135deg, #0078c9, #0d8fe6)",
      color: "#fff",
      fontWeight: 900,
      fontSize: 20,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 2,
      px: 3,
    }}
  >
    SelexStudio Release Notice

    <IconButton onClick={() => setReleaseOpen(false)} sx={{ color: "#fff" }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent sx={{ background: "#f8fafc", p: 3 }}>
    {releaseVersions.map((item, index) => (
      <Box
        key={item.version}
        sx={{
          background: "#fff",
          borderRadius: "18px",
          p: 2.5,
          mb: 2,
          border: "1px solid rgba(0,120,201,0.12)",
          boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 1 }}>
          <Chip
            label={item.version}
            sx={{
              background: "rgba(0,120,201,0.1)",
              color: "#0078c9",
              fontWeight: 800,
              fontSize: 12,
            }}
          />

          <Typography sx={{ fontSize: 16, fontWeight: 900, color: "#061d34" }}>
            {item.title}
          </Typography>
        </Box>

        <Divider sx={{ my: 1.5 }} />

        {item.details.map((detail) => (
          <Typography
            key={detail}
            sx={{
              fontSize: 13,
              color: "#475569",
              mb: 0.7,
              lineHeight: 1.7,
            }}
          >
            • {detail}
          </Typography>
        ))}
      </Box>
    ))}
  </DialogContent>
</Dialog>

    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>
    <Box sx={{ width: "min(1280px, calc(100% - 32px))",
          mx: "auto",
          marginBottom:30,
          pb: 8}}>
      <Box sx={{ textAlign: "center", mb: 5 }}>
        <Typography
          sx={{
            color: "#9e0b22",
            fontSize: 12,
            fontWeight: 950,
            letterSpacing: 1.2,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          SelexStudio Releases
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 22, md: 34 },
            fontWeight: 950,
            color: "#0078c9",
            letterSpacing: "-1.4px",
            mb: 1.5,
          }}
        >
          Choose a SelexStudio version to explore
        </Typography>

        <Typography
          sx={{
            color: "#000",
            maxWidth: 720,
            mx: "auto",
            lineHeight: 1.75,
            fontSize: 14,
          }}
        >
          Review SelexStudio release capabilities across dynamic optimization,
          objective functions, and categorical dependent-variable handling.
        </Typography>
         
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, 1fr)",
          },
          gap: 2.5,
          alignItems: "stretch",
        }}
      >
       {releases.map((release, index) => {
  const targetRoute =
    location.pathname.startsWith("/selexsim") &&
    !release.route.startsWith("/selexsim")
      ? `/selexsim${release.route}`
      : release.route;

  return (
    <Box
      key={release.version}
      onClick={() => navigate(targetRoute)}
      sx={{
        cursor: "pointer",
        position: "relative",
        p: 2.5,
        minHeight: 260,
        borderRadius: "28px",
        overflow: "hidden",
        background:
          "linear-gradient(135deg, rgba(255,255,255,0.96), rgba(248,251,255,0.94))",
        border: "1px solid rgba(0,120,201,0.16)",
        boxShadow: release.latest
          ? "0 22px 58px rgba(0,120,201,0.16)"
          : "0 14px 38px rgba(0,120,201,0.09)",
        transition: ".35s ease",
        "&:hover": {
          transform: "translateY(-8px)",
          boxShadow: "0 28px 70px rgba(0,120,201,0.18)",
          borderColor: "#0078c9",
        },
      }}
    >
      {/* your existing card content */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: 58,
                    height: 58,
                    borderRadius: "18px",
                    display: "grid",
                    placeItems: "center",
                    color: "#0078c9",
                    boxShadow: "0 12px 28px rgba(0,120,201,0.20)",
                  }}
                >
                  <RocketLaunchIcon sx={{fontSize:20}}/>
                </Box>

                {release.latest && (
                  <Box
                    sx={{
                      px: 1.4,
                      py: 0.6,
                      borderRadius: "999px",
                      bgcolor: "rgba(158,11,34,0.08)",
                      color: "#9e0b22",
                      fontSize: 11,
                      fontWeight: 900,
                      border: "1px solid rgba(158,11,34,0.14)",
                    }}
                  >
                    Latest
                  </Box>
                )}
              </Box>

            

              <Typography
                sx={{
                  fontSize: 23,
                  fontWeight: 950,
                  color: "#0078c9",
                  mb: 2,
                  lineHeight: 1.15,
                }}
              >
                {release.title}
              </Typography>
                 
             <br />
             <br />

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.8,
                  color: "#9e0b22",
                  fontWeight: 500,
                  fontSize: 14,
                  mt: "auto",
                }}
              >
                View Application <ArrowForwardIcon sx={{ fontSize: 17 }} />
              </Box>
            </Box>
    </Box>
  );
})}
      </Box>
    </Box>
  
  
  </Box>
);
}

export default SelexStudio


